<template>
    <div>
        <b-modal
          id="imageCarousel"
          size="xl"
          content-class="menu-bg-blue-transparent-modal ic-modal"
          centered
          hide-footer
          title="Field Images"
          @show="openModal()"
        >
            <!-- Custom header -->
            <template #modal-header="{ close }">
                <div class="ic-header">
                    <div class="ic-header-left">
                        <span class="ic-header-icon">
                            <fa :icon="['fas', 'images']" />
                        </span>
                        <div class="ic-header-titles">
                            <span class="ic-header-title">Field Images</span>
                            <span class="ic-header-sub">
                                <template v-if="dataLoaded && images.length > 0">{{ count }} image{{ count === 1 ? '' : 's' }} available</template>
                                <template v-else>DPR field imagery gallery</template>
                            </span>
                        </div>
                    </div>
                    <button class="ic-close" title="Close" @click="close()">
                        <fa :icon="['fas', 'times']" />
                    </button>
                </div>
            </template>

            <div class="ic-body">
                <!-- Filter bar -->
                <div class="ic-filter-panel">
                    <MMP_QueryConstructor
                        :comp="'DPR_FI'"
                        :getConditions="existingConditions"
                        :fieldImages="allImages"
                        @filter_images="filterImages($event)"
                    />
                </div>

                <!-- Gallery stage -->
                <div class="ic-stage">
                    <div class="empty-state" v-if="images.length < 1 && dataLoaded">
                        <span class="empty-state-icon">
                            <fa :icon="['fas', 'images']" />
                        </span>
                        <span class="empty-state-text">No images found</span>
                        <span class="empty-state-sub">Try adjusting the filters above.</span>
                    </div>

                    <div class="loading-state" v-else-if="!dataLoaded">
                        <span class="spinner-border loading-spinner" role="status"></span>
                        <span class="loading-text">Loading field images…</span>
                    </div>

                    <b-carousel
                      id="dpr_image_carousel"
                      controls
                      indicators
                      :interval="10000"
                      v-model="currentSlide"
                      v-if="dataLoaded && images.length > 0"
                    >
                        <b-carousel-slide v-for="(chunk, index) in chunkedImages" :key="index">
                            <template #img>
                                <div class="slide">
                                    <div class="img-container" v-for="(img, imgIndex) in chunk" :key="imgIndex">
                                        <div class="img-frame">
                                            <img :src="annotation + img.image" alt="Open full image" class="img card-item" @click="openImageInNewTab($event, img)"/>
                                            <span class="img-zoom-hint">
                                                <fa :icon="['fas', 'expand']" />
                                            </span>
                                        </div>
                                        <div class="img-text-container">
                                            <div class="text-container" v-if="img.dpr_id && img.upload_date && img.username">
                                                <div class="info-row">
                                                    <span class="info-label">DPR ID</span>
                                                    <span class="info-value">{{ img.dpr_id }}</span>
                                                </div>
                                                <div class="info-row">
                                                    <span class="info-label">Uploaded On</span>
                                                    <span class="info-value">{{ img.upload_date.split('T')[0] }}</span>
                                                </div>
                                                <div class="info-row">
                                                    <span class="info-label">Uploaded By</span>
                                                    <span class="info-value">{{ img.username }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </b-carousel-slide>
                    </b-carousel>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios'
import MMP_QueryConstructor from './MMP_QueryConstructor.vue';
export default {
    name: 'MMP_ImageCarousel',
    components: {
        MMP_QueryConstructor
    },
    data() {
        return {
            dprId: null,
            date: null,
            numberOfColumns: 5,
            images: [],
            imageInfo: [],
            annotation: `data:image/png;base64,`,
            dataLoaded: false,
            last_imageId: 0,
            first_imageId: 0,
            count: 0,
            allImages: [],
            prevDisabled: true,
            nextDisabled: false,
            currentSlide: 0, // Tracks the current slide
            existingConditions: []
        }
    },
    methods: {
        filterImages(filteredImages) {
            this.images = filteredImages
            this.count = this.images.length
            this.currentSlide = 0
            setTimeout(() => {
                this.updateIndicatorsVisibility(0)
            }, 1000)
        },
        async getImageList() {
            this.dataLoaded = false
            this.imageInfo = []
            this.images = []
            if (sessionStorage.token) {
                await axios
                    .get(process.env.API_LOCATION + '/api/dpr/getImages', {
                        headers: {
                            'x-auth-token': sessionStorage.token
                        },
                        params: {
                            date: this.date,
                            dprid: this.dprId,
                        }
                    })
                    .then(response => {
                        if (response.data.info.length > 0) {
                            this.imageInfo = response.data.info
                            this.allImages = response.data.images
                            this.images = response.data.images
                            this.count = this.images.length
                        }
                        this.dataLoaded = true
                    })
                    .catch(function (error) {
                        console.log(error)
                    })

                this.updateIndicatorsVisibility(this.currentSlide)
            } else {
                console.log('No User Token')
            }
        },
        openImageInNewTab(e, img) {
            let info = this.imageInfo.filter(e => e.image_path === img.path)[0]
            var newTab = window.open()
            newTab.document.title = info.image_path.split('\\')[1]
            newTab.document.body.style =
                'text-align:center ;background:black ; max-height: 100%; max-width: 100%;'
            newTab.document.body.style.zoom = '60%'
            newTab.document.body.innerHTML =
                "<img src='" +
                e.target.currentSrc +
                "' style='max-height: 1500px;width: auto;margin-top:6%;'>"
        },
        openModal() {
            this.getImageList()
        },
        updateIndicatorsVisibility(currentIndex) {
            // Get all indicator elements
            const indicators = document.querySelectorAll(
                '#dpr_image_carousel .carousel-indicators li'
            );
            const totalIndicators = indicators.length;

            indicators.forEach((indicator, index) => {
                // Determine the visible range
                let isVisible;
                if (currentIndex <= 1) {
                    // For edge cases at the start of the carousel
                    isVisible = index <= 4;
                } else if (currentIndex >= totalIndicators - 2) {
                    // End edge cases: show last 5 indicators
                    isVisible = index >= totalIndicators - 5;
                } else {
                    // For other cases, use ±2 range
                    isVisible = index >= currentIndex - 2 && index <= currentIndex + 2;
                }

                // Apply visibility based on the range
                indicator.style.display = isVisible ? 'inline-block' : 'none';
            });
        }
    },
    computed: {
        // Compute chunks of 3 images
        chunkedImages() {
            const chunkSize = 3;
            const chunks = [];
            for (let i = 0; i < this.images.length; i += chunkSize) {
                chunks.push(this.images.slice(i, i + chunkSize));
            }
            return chunks;
        }
    },
    watch: {
        currentSlide: function(newValue) {
            setTimeout(() => {
                this.updateIndicatorsVisibility(newValue)
            }, 1000)
        }
    },
    mounted() {
        // Initialize visibility on load
        this.updateIndicatorsVisibility(this.currentSlide);
    },
}
</script>
<style scoped>
/* ── Custom header ── */
.ic-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.9rem 1.35rem;
}

.ic-header-left {
    display: flex;
    align-items: center;
    gap: 0.85rem;
}

.ic-header-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.16);
    color: #ffffff;
    font-size: 1.05rem;
}

.ic-header-titles {
    display: flex;
    flex-direction: column;
    line-height: 1.25;
}

.ic-header-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 0.2px;
}

.ic-header-sub {
    font-size: 0.75rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.7);
}

.ic-close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 9px;
    background: rgba(255, 255, 255, 0.12);
    color: #ffffff;
    font-size: 0.95rem;
    cursor: pointer;
    transition: background 0.15s ease, transform 0.15s ease;
}

.ic-close:hover {
    background: rgba(255, 255, 255, 0.26);
    transform: translateY(-1px);
}

/* ── Body ── */
.ic-body {
    display: flex;
    flex-direction: column;
    background: #ffffff;
}

.ic-filter-panel {
    padding: 1rem 1.25rem;
    background: #f7fafd;
    border-bottom: 1px solid rgba(6, 60, 109, 0.08);
}

.ic-stage {
    position: relative;
    padding: 1.25rem 1rem 0.5rem;
    background:
        radial-gradient(1200px 320px at 50% -10%, rgba(26, 93, 168, 0.08), rgba(26, 93, 168, 0) 70%),
        #eef3f9;
    min-height: clamp(20rem, 55vh, 32.5rem);
    display: flex;
    flex-direction: column;
    justify-content: center;
}

/* ── Loading state ── */
.loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.9rem;
    padding: 4rem 1rem;
    color: #4a6880;
}

.loading-spinner {
    width: 2.2rem;
    height: 2.2rem;
    border-width: 3px;
    color: #1a5da8;
}

.loading-text {
    font-size: 0.9rem;
    font-weight: 600;
    color: #4a6880;
}

.filter-panel {
    width: 100%;
    height: clamp(3.125rem, 7vh, 6.25rem);
    display: flex;
    justify-content: center;
    align-items: center;
}

.slide {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    min-height: clamp(24rem, 58vh, 34.375rem);
    width: 100%;
    gap: clamp(1.5rem, 3vw, 3.125rem);
    padding-bottom: 20px;
}

.img-container {
    width: clamp(16.25rem, 21vw, 21.875rem);
    height: auto;
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    background: #ffffff;
    overflow: hidden;
    border: 1px solid rgba(6, 60, 109, 0.08);
    box-shadow: 0 10px 28px rgba(6, 60, 109, 0.16);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.img-container:hover {
    transform: translateY(-5px);
    box-shadow: 0 18px 42px rgba(6, 60, 109, 0.26);
}

/* Image frame with zoom hint */
.img-frame {
    position: relative;
    width: 100%;
    overflow: hidden;
    background: #eef2f6;
}

.img-frame .img.card-item {
    display: block;
    width: 100%;
    height: clamp(15rem, 36vh, 21.875rem);
    object-fit: cover;
    cursor: zoom-in;
    transition: transform 0.3s ease;
}

.img-frame:hover .img.card-item {
    transform: scale(1.04);
}

.img-zoom-hint {
    position: absolute;
    top: 10px;
    right: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: rgba(6, 60, 109, 0.75);
    color: #fff;
    font-size: 0.75rem;
    opacity: 0;
    transform: translateY(-4px);
    transition: opacity 0.2s ease, transform 0.2s ease;
    pointer-events: none;
}

.img-frame:hover .img-zoom-hint {
    opacity: 1;
    transform: translateY(0);
}

/* Metadata footer */
.img-text-container {
    width: 100%;
    display: flex;
    background: linear-gradient(135deg, #063c6d 0%, #0a4f8f 100%);
    color: #ffffff;
    padding: 12px 16px;
}

.text-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 7px;
}

.info-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}

.info-label {
    font-size: 0.66rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgba(255, 255, 255, 0.65);
    white-space: nowrap;
}

.info-value {
    font-size: 0.86rem;
    font-weight: 700;
    color: #ffffff;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.img {
    max-width: 100%;
    max-height: 100%;
}

.main-img {
    height: auto;
    width: 100%;
}

.card-list {
    display: grid;
    grid-gap: 1em;
    color: rgb(238, 238, 238);
    margin-bottom: 1%;
    margin-top: 0.5%;
    padding: 1%;
}

.card-item {
    background-color: white;
    width: 100%;
    cursor: zoom-in;
}

/* Empty state */
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 3.5rem 1rem;
    color: #4a6880;
}

.empty-state-icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 66px;
    height: 66px;
    border-radius: 50%;
    background: rgba(6, 60, 109, 0.08);
    color: #1a5da8;
    font-size: 1.5rem;
    margin-bottom: 0.35rem;
}

.empty-state-text {
    font-size: 1.02rem;
    font-weight: 700;
    color: #063c6d;
}

.empty-state-sub {
    font-size: 0.85rem;
    color: #7089a3;
}

.mmp-button {
    background-color: #1b66ac;
    color: white;
}

.mmp-button:hover {
    opacity: 0.8;
}

</style>

<!-- Unscoped: styles the BootstrapVue modal shell / carousel internals (not reachable by scoped CSS) -->
<style>
.modal-content.ic-modal {
    border: none !important;
    border-radius: 16px !important;
    overflow: hidden;
    box-shadow: 0 24px 70px rgba(6, 60, 109, 0.34) !important;
}

.ic-modal .modal-header {
    padding: 0 !important;
    background: linear-gradient(135deg, #063c6d 0%, #0a4f8f 100%) !important;
    border-bottom: none !important;
    border-radius: 0 !important;
}

.ic-modal .modal-body {
    padding: 0 !important;
    background: #ffffff !important;
}

/* Carousel controls → navy circular buttons */
.ic-modal .carousel-control-prev,
.ic-modal .carousel-control-next {
    width: 58px;
    align-items: center;
    opacity: 1;
}

.ic-modal .carousel-control-prev-icon,
.ic-modal .carousel-control-next-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #063c6d;
    background-position: center;
    background-size: 42% 42%;
    box-shadow: 0 4px 12px rgba(6, 60, 109, 0.35);
    transition: background-color 0.15s ease, transform 0.15s ease;
}

.ic-modal .carousel-control-prev:hover .carousel-control-prev-icon,
.ic-modal .carousel-control-next:hover .carousel-control-next-icon {
    background-color: #0a4f8f;
    transform: scale(1.08);
}

/* Indicators → pill-style */
.ic-modal .carousel-indicators {
    margin-bottom: 6px;
}

.ic-modal .carousel-indicators li {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #b8cbe0;
    border: none;
    opacity: 1;
    transition: background-color 0.2s ease, width 0.2s ease;
}

.ic-modal .carousel-indicators li.active {
    background-color: #063c6d;
    width: 22px;
    border-radius: 6px;
}
</style>